import axios from 'axios';

/* JS */
import * as Common from 'assets/js/Common';

//const hostUrl = 'http://192.168.0.125:8293/';
const hostUrl = 'https://api.ustind.in/';

export default function setAuthorizationToken(token) {
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common['Authorization'];
  }
}

export async function sendPost(url, param, cbSuccess) {
  await axios.post(hostUrl + url, param).then(res => {
    if (res.data['apiCode'] !== 'S001') {
      console.log('ERROR');
      Common.errorMsg(res.data.message);

      return;
    }

    console.log('SUCCESS');
    cbSuccess(res.data);
  }).catch(res => {
    if (!Common.isEmpty(res.response)) {
      console.log('ERROR');
      Common.errorMsg(res.response.data.message);
    }
  });
}

export async function sendPostInHq(url, param, cbSuccess) {
  await axios.post(hostUrl + url, param).then(res => {

    console.log('SUCCESS');
    cbSuccess(res.data);
  }).catch(res => {
    if (!Common.isEmpty(res.response)) {
      console.log('ERROR');
      Common.errorMsg(res.response.data.message);
    }
  });
}

export async function sendPut(url, param, cbSuccess) {
  await axios.put(hostUrl + url, param).then(res => {
    if (res.data['apiCode'] !== 'S001') {
      console.log('ERROR');
      Common.errorMsg(res.data.message);

      return;
    }

    console.log('SUCCESS');
    cbSuccess(res.data);
  }).catch(res => {
    if (!Common.isEmpty(res.response)) {
      console.log('ERROR');
      Common.errorMsg(res.response.data.message);
    }
  });
}

export async function sendPatch(url, param, cbSuccess) {
  await axios.patch(hostUrl + url, param).then(res => {
    if (res.data['apiCode'] !== 'S001') {
      console.log('ERROR');
      Common.errorMsg(res.data.message);

      return;
    }

    console.log('SUCCESS');
    cbSuccess(res.data);
  }).catch(res => {
    if (!Common.isEmpty(res.response)) {
      console.log('ERROR');
      Common.errorMsg(res.response.data.message);
    }
  });
}

export async function sendDelete(url, param, cbSuccess) {
  url = `${hostUrl}${url}?`;

  for (let i = 0; i < Object.keys(param).length; i++) {
    url += `${Object.keys(param)[i]}=${Object.values(param)[i]}&`;
  }

  await axios.delete(url.slice(0, url.length - 1)).then(res => {
    cbSuccess(res.data);
  }).catch(res => {
    if (!Common.isEmpty(res.response)) {
      Common.errorMsg(res.response.data.message);
    }
  });
}

export async function sendGet(url, param, cbSuccess) {
  url = `${hostUrl}${url}?`;

  for (let i = 0; i < Object.keys(param).length; i++) {
    url += `${Object.keys(param)[i]}=${Object.values(param)[i]}&`;
  }

  await axios.get(url.slice(0, url.length - 1)).then(res => {
    cbSuccess(res.data);
  }).catch(res => {
    if (!Common.isEmpty(res.response)) {
      Common.errorMsg(res.response.data.message);
    }
  });
}

export async function getCommonCode(codeType, cbSuccess) {
  await axios.get(`${hostUrl}common/code/list?codeType=${codeType}`).then(res => {
    if (res.data['apiCode'] !== 'S001') {
      console.log('ERROR');
      Common.errorMsg(res.data.message);

      return;
    }

    console.log('SUCCESS');
    cbSuccess(res.data);
  });
}

export async function fileUpload(url, param) {
  return await axios.post(hostUrl + url, param, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function sendErpS3Upload(param) {
  return await axios.post(`${hostUrl}file/meet/s3upload`, param, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export let SYSTEM_SERVER_DATE;

export async function getCurrentDate() {
  await sendGet('common/current/date', {}, callback_SYSTEM_SERVER_DATE);
}

function callback_SYSTEM_SERVER_DATE(res) {
  SYSTEM_SERVER_DATE = res['resultObject'];
}

export async function fn_GetServerDate(_type) {
  await getCurrentDate();

  let returnValue;

  let s_yyyy = parseInt(SYSTEM_SERVER_DATE.substring(0, 4));
  let s_MM = parseInt(SYSTEM_SERVER_DATE.substring(5, 7)) - 1;
  let s_dd = parseInt(SYSTEM_SERVER_DATE.substring(8, 10));
  let s_HH = parseInt(SYSTEM_SERVER_DATE.substring(11, 13));
  let s_mm = parseInt(SYSTEM_SERVER_DATE.substring(14, 16));
  let s_ss = parseInt(SYSTEM_SERVER_DATE.substring(17, 19));

  let today = new Date(s_yyyy, s_MM, s_dd, s_HH, s_mm, s_ss);

  let yyyy = today.getFullYear();
  let MM = today.getMonth() + 1;
  let dd = today.getDate();
  let HH = today.getHours();
  let mm = today.getMinutes();
  let ss = today.getSeconds();

  let week = ['일', '월', '화', '수', '목', '금', '토'];

  MM = MM < 10 ? '0' + String(MM) : String(MM);
  dd = dd < 10 ? '0' + String(dd) : String(dd);
  HH = HH < 10 ? '0' + String(HH) : String(HH);
  mm = mm < 10 ? '0' + String(mm) : String(mm);
  ss = ss < 10 ? '0' + String(ss) : String(ss);

  switch (_type) {
    case 'YYYY':
      returnValue = yyyy;

      break;
    case 'YY':
      returnValue = yyyy.toString().substring(2, 4);

      break;
    case 'MM':
      returnValue = MM;

      break;
    case 'DD':
      returnValue = dd;

      break;
    case 'YYYYMMDD':
      returnValue = yyyy + MM + dd;

      break;
    case 'DATE':
      returnValue = yyyy + '-' + MM + '-' + dd;

      break;
    case 'DATETIME':
      returnValue = yyyy + '-' + MM + '-' + dd + ' ' + HH + ':' + mm + ':' + ss;

      break;
    case 'TODAY_DATE_KOR':
      returnValue = yyyy + '년' + MM + '월' + dd + '일';

      break;
    case 'TODAY_DATE_TIME_KOR':
      returnValue = yyyy + '년' + MM + '월' + dd + '일 ' + HH + '시' + mm + '분' + ss + '초';

      break;
    case 'TODAY_DATE_TIME_Excel':
      returnValue = yyyy + MM + dd + ' ' + HH + mm + ss;

      break;
    case 'TODAY_DATE_WEEK_KOR':
      returnValue = yyyy + '년' + MM + '월' + dd + '일 ' + week[today.getDay()] + '요일';

      break;
    case 'TODAY_DATE':
      returnValue = SYSTEM_SERVER_DATE;

      break;
    case 'YESTERDAY_DATE':
      let yesterday = new Date(today);

      yesterday.setDate(yesterday.getDate() - 1);

      yyyy = yesterday.getFullYear();
      MM = yesterday.getMonth() + 1;
      dd = yesterday.getDate();

      MM = MM < 10 ? '0' + String(MM) : String(MM);
      dd = dd < 10 ? '0' + String(dd) : String(dd);

      returnValue = yyyy + '-' + MM + '-' + dd;

      break;
    default:
      returnValue = yyyy + '-' + MM + '-' + dd;

      break;
  }

  return returnValue;
}
